import React from "react";

function Role() {
  return (
    <div>
      <h3>Roles Page</h3>
    </div>
  );
}
export default Role;
